import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import defaultAvatar from '../user.png';
import logo from '../white-logo.png';
import blackLogo from '../black-logo.png';
import { Col, Container, Nav, Navbar, Offcanvas, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import FooterComponent from "../components/shared/FooterComponent";

import { BsFillDeviceSsdFill } from 'react-icons/bs'
import { BiSupport, BiCog } from 'react-icons/bi';
import { CgLogOff } from 'react-icons/cg';

import { useAuthDispatch, useAuthState } from "../context/AuthContext";
import { AiOutlineCloudDownload } from "react-icons/ai";
import { FaBell, FaInfoCircle, FaQuestionCircle } from "react-icons/fa";

const CustomerDashLayout = () => {

    // initial vars
    const { user, tooltipsTrigger } = useAuthState();
    const dispatch = useAuthDispatch(); 
    const navigate = useNavigate();
    
    const [navBg, setNavBg] = useState('bg-energo');
    


    const changeNavBg = () => {
        window.scrollY >= 10 ? setNavBg('bg-energo-opaque') : setNavBg('bg-energo');
    }


    useEffect(() => {
        window.addEventListener('scroll', changeNavBg);
        return () => {
            window.removeEventListener('scroll', changeNavBg);
        }
    }, []);

    const logout = (e) => {
        e.preventDefault();
        dispatch('LOGOUT');
        navigate("/logout");
    }


    const toggleTooltips = () => {
        if (tooltipsTrigger === true) dispatch("TOOLTIPS_OFF");
        else dispatch('TOOLTIPS_ON');
    }

    return (
        <>
            <header className="App-header">
                <Navbar variant={navBg === 'bg-energo' ? 'dark' : 'light'} expand="false" fixed="top" className={navBg}>
                    <Container fluid className="upper-nav">
                        <Navbar.Brand href="/dashboard/">
                            <img width={100} src={navBg === 'bg-energo' ? logo : blackLogo} alt="brand" className="img-fluid" />
                        </Navbar.Brand>

                        <div style={{display: "flex"}}>
                            <b
                                style={{marginRight: 10, marginTop: 10}}
                            >{user?.name}</b>
                            <a 
                                href="tooltips/"
                                onClick={e => {e.preventDefault(); toggleTooltips()}}
                                className={tooltipsTrigger !== undefined && tooltipsTrigger === true?
                                    "text-warning glow-effect":
                                    navBg === "bg-energo"?
                                    "text-light" : "text-dark"}
                            >
                                <FaInfoCircle size={27} style={{marginTop: 6, marginRight: 10}} />
                            </a>
                            <Navbar.Toggle aria-controls="offcanvasNavbar-expand-xxl" />
                        </div>


                        <Navbar.Offcanvas aria-labelledby="offcanvasNavbarLabel-expand-xxl" placement="end">
                            <Offcanvas.Header closeButton className="shadow-sm">
                                <Offcanvas.Title className="text-energo">
                                    <Row>
                                        <Col xs="11">
                                            ENERGO Managementportal
                                        </Col>
                                        <Col xs="1" className="text-end">
                                            <a href="/dashboard/profile/" className="link-energo-dark">
                                                <BiCog size={30} />
                                            </a>
                                        </Col>
                                    </Row>
                                </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                                <Row>
                                    <Col xs="12" className="text-center">
                                        <OverlayTrigger
                                            placement="left"
                                            overlay={
                                                <Tooltip>
                                                    Sie können ihr Profil-Bild jederzeit in den <BiCog /> Einstellungen ändern.
                                                    Wenn Ihre E-Mail-Adresse bei gravatar.com hinterlegt ist, verwenden
                                                    wir anfänglich das dort verfügbare Bild.
                                                </Tooltip>
                                            }
                                        >
                                            <div
                                                className="avatar-image"
                                                style={{
                                                    backgroundImage: `url(${user?.image_1920 && user.image_1920 !== "False" ? 'data:image/*;base64,' + user.image_1920 : defaultAvatar})`,
                                                    backgroundSize: 'contain',
                                                    backgroundPosition: 'center',
                                                    backgroundRepeat: 'no-repeat'
                                                }}
                                            >
                                            </div>
                                        </OverlayTrigger>


                                        <br /> <br />
                                        <h4>{user?.name}</h4>
                                        <p className="text-muted">{user?.x_qr_login}</p>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col xs="12">
                                        <Nav className="justify-content-end flex-grow-1 pe-3">
                                            <Nav.Link href="/dashboard/news/">
                                                <FaBell className="text-primary" size="30" />
                                                <span className="align-middle nav-links">News</span>
                                            </Nav.Link>
                                            <Nav.Link href="/dashboard/neuedokumente/">
                                                <AiOutlineCloudDownload className="text-violet" size="30" />
                                                <span className="align-middle nav-links">Neue Dokumente</span>
                                            </Nav.Link>
                                            <Nav.Link href="/dashboard/anlagen/">
                                                < BsFillDeviceSsdFill className="text-energo" size="30" />
                                                <span className="align-middle nav-links">Meine Anlagen</span>
                                            </Nav.Link>
                                            <Nav.Link href="/dashboard/support/">
                                                <BiSupport className="text-warning" size="30" />
                                                <span className="align-middle nav-links">Support</span>
                                            </Nav.Link>
                                            <Nav.Link href="/dashboard/faq/" disabled style={{opacity: "0.2", background: "white"}}>
                                                <FaQuestionCircle className="text-info" size="30" />
                                                <span className="align-middle nav-links">FAQ</span>
                                            </Nav.Link>
                                            <Nav.Link onClick={e => logout(e)}>
                                                <CgLogOff className="text-danger" size="30" />
                                                <span className="align-middle nav-links">Abmelden</span>
                                            </Nav.Link>
                                        </Nav>
                                    </Col>
                                </Row>
                            </Offcanvas.Body>
                        </Navbar.Offcanvas>
                    </Container>
                </Navbar>
            </header>
            <main style={{ marginTop: "150px" }}>
                <Outlet />
            </main>
            <FooterComponent />
        </>
    )
}

export default CustomerDashLayout;


//<img src={user?.image_1920 && user.image_1920 !== "False"? 'data:image/jpeg;base64,'+user.image_1920: defaultAvatar} alt="avatar" className="img-fluid img-darken" width={200} />